<template>
  <idc-component-adjustment-monday :can-edit="canEdit" />
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardAdjustmentMonday',
    components: {
      IdcComponentAdjustmentMonday: () => import('@/components/idc/adjustment/monday/Monday.vue'),
    },
    props: {
      canEdit: {
        type: Boolean,
        default: () => false,
      },
    },
  })
</script>
